import React from "react";
import { CartItemCards } from "presto-react-components";
import _ from "lodash";
import utils from "../../utils";

export default function CartItemCard(props) {
  let forwardProps = { ...props };
  if (!_.isFunction(forwardProps?.priceAccessorMethod)) {
    forwardProps.priceAccessorMethod = (product, flag = false) => {
      if (flag) {
        return utils.formattedPriceRoundOff(
          product?.price?.total_price + product?.price?.tax,
          true
        );
      } else {
        return product?.formatCurrency2;
      }
    };
  }
  return <CartItemCards.CartItemCard1 {...forwardProps} />;
}
